import { format, getQuarter } from 'date-fns';
import queryString from 'query-string';
import * as React from 'react';
import { Col, Row } from 'react-bootstrap';
import { IFilters } from 'src/interfaces';

import {
    saveDailyFormFilter,
    saveLineChartFilter,
    saveMonthlyFormFilter,
    saveQuarterlyFormFilter,
} from '../../actions/dashboardAction';
import { IDailyForms, IFlaggedFormDetails, IHistory, IMonthlyForms, IQuarterlyForms } from '../../interfaces';
import { PlantModel } from '../../model/PlantModel';
import {
    constructChartData,
    getFlaggedForms,
    getFormDetails,
    getFormSummaryData,
    getPlantDetails,
    mapDataToState,
} from '../../services/dashboardService';
import { getAllPlantsByRegion } from '../../services/plantService';
import { splitDate } from '../../utils/generalUtils';
import { LineChart } from '../reusableComponents/ChartComponents/LineChart';
import { RDatePicker } from '../reusableComponents/DatePicker';
import { ListModal } from '../reusableComponents/ListModal';
import { DetailsModal } from '../reusableComponents/ListModal/DetailsModal';
import { Loader } from '../reusableComponents/Loader';
import { RegionFilter } from '../reusableComponents/RegionFilter';
import { ToggleSwitch } from '../reusableComponents/ToggleSwitch.tsx';
import { DailyChart } from './DailyChart';
import { FlaggedFormListItem } from './FlaggedFormListItem';
import { MonthlyChart } from './MonthlyChart';
import { PlantListItem } from './PlantListItem';
import { QuarterlyChart } from './QuarterlyChart';
import { showPlantListModal } from '../../actions/modalActions';
import { inspectionType } from '../../constants/generals';

export interface IDashboardDataProps {
    dailyForms: IDailyForms;
    monthlyForms: IMonthlyForms;
    quarterlyForms: IQuarterlyForms;
    lineChartData: {
        dailyForms: IDailyForms;
        Monthly: IMonthlyForms;
        Quarterly: IQuarterlyForms;
    };
    history: IHistory;
    dailyFlaggedForms: IFlaggedFormDetails[];
    monthlyFlaggedForms: IFlaggedFormDetails[];
    quarterlyFlaggedForms: IFlaggedFormDetails[];
    filterData: {
        lineChartFilter: IFilters;
        dailyFilter: IFilters;
        monthlyFilter: IFilters;
        quarterlyFilter: IFilters;
    };
    resetFilters: boolean;
    dailyFlaggedFormCount: string;
    monthlyFlaggedFormCount: string;
    quarterlyFlaggedFormCount: string;
    location: any;
}

export interface IDashboardDataState {
    activeIndex: number;
    filterQuarterlyBy: string;
    dashboardFilterValue: Date;
    filterDailyBy: string;
    filterMonthlyBy: string;
    barColors: string[];
    lineChartDataKey: string[];
    lineChartData: Object[];
    regionFilter: string;
    formType: string;
    isLoading: boolean;
    showFilter: boolean;
    dailyFilter: Date;
    monthlyFilter: Date;
    quarterlyFilter: Date;
}

export class DashboardData extends React.Component<IDashboardDataProps, IDashboardDataState> {
    constructor(props: IDashboardDataProps) {
        super(props);
        const getDefaultDate = (type) => {
            if (type === 'date') {
                return new Date();
            }
            if (type === 'month') {
                return new Date();
            }
        };
        let date = new Date();
        let region = 'All';
        let dailyFilter = new Date();
        let monthlyFilter = new Date();
        let quarterlyFilter = new Date();
        if (this.props.location.search) {
            date = queryString.parse(this.props.location.search).date;
            region = queryString.parse(this.props.location.search).region;
            dailyFilter = new Date(queryString.parse(this.props.location.search).daily);
            monthlyFilter = new Date(queryString.parse(this.props.location.search).monthly);
            quarterlyFilter = new Date(queryString.parse(this.props.location.search).quarterly);
        }
        const { lineChartFilter } = props.filterData;
        this.state = {
            activeIndex: 0, showFilter: true,
            dashboardFilterValue: new Date(date),
            regionFilter: region,
            dailyFilter,
            monthlyFilter,
            formType: 'Daily',
            quarterlyFilter,
            barColors: ['59AFFF', 'BFFF4C'], 
            lineChartDataKey: ['Daily Form', 'Plant Preventive'], lineChartData: null, isLoading: false,
            filterMonthlyBy: 'All', filterQuarterlyBy: 'All', filterDailyBy: 'All'
        }; 
    }

    formTypes = ['Daily Forms', 'Monthly Forms', 'Quarterly Forms'];

    componentWillReceiveProps(nextProps: IDashboardDataProps) {
        if (nextProps.resetFilters) {
            this.setState({
                dashboardFilterValue: new Date(),
                regionFilter: ''
            });
        }
    }

    handleActiveTab = (index: number, formType?: string, filterBy?: string) => {
        
        this.setState({
            filterDailyBy: (filterBy && filterBy) || 'All',
            filterMonthlyBy: (filterBy && filterBy) || 'All',
            filterQuarterlyBy: (filterBy && filterBy) || 'All',
            activeIndex: index,
            formType: (formType && formType.split(' ')[0]) || this.state.formType,
        });
        mapDataToState(this.props.lineChartData, filterBy, this, index, this.props.filterData.lineChartFilter);
    }

    handleLineChartFilter = async (val) => {
        if (!val) {
            return;
        }
        this.setState({
            dashboardFilterValue: new Date(val),
            dailyFilter: new Date(val),
            monthlyFilter: new Date(val),
            quarterlyFilter: new Date(val),
            isLoading: true,
            filterDailyBy: 'All',
            filterMonthlyBy: 'All',
            filterQuarterlyBy: 'All'
        });
        const region = this.state.regionFilter || 'All';
        const date = format(new Date(), 'YYYY-MM-DD').toString();
        const { mm, dd, yyyy } = splitDate(format(val, 'YYYY-MM-DD'));
        const q = getQuarter(date);
        saveLineChartFilter(val, region);
        saveDailyFormFilter(val, region);
        saveMonthlyFormFilter(val, region);
        saveQuarterlyFormFilter(val, region);
        await getFlaggedForms('All', mm, dd, yyyy, region, this);
        await getFormSummaryData(mm, dd, yyyy, region, this);
        const queryString = `?date=${format(date, 'YYYY-MM-DD')}&&region=${this.state.regionFilter}`;
        /*tslint:disable-next-line*/
        const dashboardQueryString = `/dashboard?date=${format(val, 'YYYY-MM-DD')}&&region=${this.state.regionFilter}&&monthly=${format(val, 'YYYY-MM-DD')}&&daily=${format(val, 'YYYY-MM-DD')}&&quarterly=${format(val, 'YYYY-MM-DD')}`;
        this.props.history.push(`${dashboardQueryString}`);
        this.handleActiveTab(this.state.activeIndex, this.formTypes[this.state.activeIndex]);
        this.setState({
            isLoading: false
        });
    }

    handleLineChartClick = async ({ name: dd, month: mm, year: yyyy, region }) => {
        dd = dd.length === 1 ? `0${dd}` : dd;
        const date = new Date(`${yyyy}-${mm}-${dd}T17:00:00.00Z`);
        this.setState({
            dashboardFilterValue: date,
            dailyFilter: date,
            monthlyFilter: date,
            quarterlyFilter: date,
            isLoading: true,
        });
        const q = getQuarter(date);
        await getFlaggedForms('All', mm, dd, yyyy, this.state.regionFilter, this);
        await getFormSummaryData(mm, dd, yyyy, this.state.regionFilter, this);
        /*tslint:disable-next-line*/
        const dashboardQueryString = `/dashboard?date=${format(date, 'YYYY-MM-DD')}&&region=${this.state.regionFilter}&&monthly=${format(date, 'YYYY-MM-DD')}&&daily=${format(date, 'YYYY-MM-DD')}&&quarterly=${format(date, 'YYYY-MM-DD')}`;
        this.props.history.push(`${dashboardQueryString}`);
        this.handleActiveTab(this.state.activeIndex, this.formTypes[this.state.activeIndex], this.state.filterDailyBy);
        this.setState({
            isLoading: false
        });
    }

    handleFilterSelect = (stateKey, value) => {
        this.setState({ [stateKey]: value });
        this.handleActiveTab(this.state.activeIndex, '', value);
    }

    renderDailyFilterDropdown = () => {
        return <select
            onChange={e => this.handleFilterSelect('filterDailyBy', e.target.value)}
            value={this.state.filterDailyBy}
        >
            <option value="All" >All</option>
            <option value="DailyForm" >DailyForm</option>
            <option value="PlantPreventive" >Plant Preventive</option>
        </select>;

    }

    renderMonthlyFilterDropdown = () => {
        return <select
            onChange={e => this.handleFilterSelect('filterMonthlyBy', e.target.value)}
            value={this.state.filterMonthlyBy}
        >
            <option value="All" >All</option>
            <option value="MonthlySPCC" >SPCC Form</option>
            <option value="MonthlySpillLogs" >SpillLogs</option>
            <option value="MonthlySW" >SW Form</option>
            <option value="MonthlyUSTRect" >USTRect Form</option>
            <option value="MonthlyUSTSpill" >USTSpill Form</option>
        </select>;
    }

    renderQuarterlyFilterDropdown = () => {
        return <select
            onChange={e => this.handleFilterSelect('filterQuarterlyBy', e.target.value)}
            value={this.state.filterQuarterlyBy}
        >
            <option value="All" >All</option>
            <option value="ShopInspection">{inspectionType('ShopInspection')}</option>
            <option value="QTRVisual">{inspectionType('QTRVisual')}</option>
        </select>;
    }

    executeFilter = async (key, value) => {
        const { dashboardFilterValue } = this.state;
        this.setState({
            regionFilter: value,
            isLoading: true,
            filterDailyBy: '',
            filterMonthlyBy: '',
            filterQuarterlyBy: ''
        });
        const date = format(new Date(), 'YYYY-MM-DD').toString();
        const { mm, dd, yyyy } = dashboardFilterValue ?
            splitDate(format(dashboardFilterValue, 'YYYY-MM-DD')) :
            splitDate(date);
        const q = getQuarter(date);
        await getFlaggedForms('All', mm, dd, yyyy, value, this);
        await getFormSummaryData(mm, dd, yyyy, value, this);
        this.handleActiveTab(this.state.activeIndex, this.formTypes[this.state.activeIndex]);
        saveLineChartFilter(dashboardFilterValue, value);
        /*tslint:disable-next-line*/
        const dashboardQueryString = `/dashboard?date=${format(date, 'YYYY-MM-DD')}&&region=${this.state.regionFilter}&&monthly=${format(date, 'YYYY-MM-DD')}&&daily=${format(date, 'YYYY-MM-DD')}&&quarterly=${format(date, 'YYYY-MM-DD')}`;        /*tslint:disable-next-line*/
        this.props.history.push(`${dashboardQueryString}`);
        this.setState({
            isLoading: false
        });
    }

    handleFilterReset = async () => {
        this.setState({
            isLoading: true,
            dashboardFilterValue: new Date(),
            dailyFilter: new Date(),
            monthlyFilter: new Date(),
            quarterlyFilter: new Date(),
            regionFilter: 'All',
            filterMonthlyBy: 'All',
            filterQuarterlyBy: 'All',
            filterDailyBy: 'All'
        });
        const date = format(new Date(), 'YYYY-MM-DD').toString();
        const { mm, dd, yyyy } = splitDate(date);
        await getFlaggedForms('All', mm, dd, yyyy, 'All', this);
        await getFormSummaryData(mm, dd, yyyy, 'All', this);
        this.handleActiveTab(this.state.activeIndex, this.formTypes[this.state.activeIndex]);
        this.props.history.push('/dashboard');
        this.setState({
            isLoading: false
        });
        return;
    }

    handleOnCompletedFlaggedFormClick = () => {
        const dashboardQueryString =
        `/flagged-forms?searchFor=complete&&formType=${this.state.formType || ''}&&pageNum=1`;
        this.props.history.push(dashboardQueryString);
    }

    handleOnInCompletedFlaggedFormClick = () => {
        const dashboardQueryString =
        `/flagged-forms?searchFor=incomplete&&formType=${this.state.formType || ''}&&pageNum=1`;
        this.props.history.push(dashboardQueryString);
    }

    render() {
        const { dailyForms, monthlyForms, lineChartData, quarterlyForms, filterData: { lineChartFilter } } = this.props;
        if (!dailyForms || !monthlyForms || !quarterlyForms || !lineChartData || !lineChartFilter) {
            return <div></div>;
        }
        const { monthlyFormData, dailyFormData, dailyFormSummary, quarterlySummary } =
            constructChartData(lineChartData, dailyForms, monthlyForms, quarterlyForms,
                this.props.filterData.lineChartFilter); 
        return [
            <div key={1} className="dashboard">
                {this.state.isLoading ? <Loader type="submission" /> : ''}
                <ListModal
                    id="dashboard"
                    listTitle="Incomplete Plants"
                    modalTitle="Incomplete"
                    listHeadings={['#', 'PlantID', 'Remind']}
                    listItemComponent={PlantListItem}
                    promise={(plantID) => {
                        getPlantDetails(plantID);
                    }}
                    initialPromise={async () => {
                        if (PlantModel.list().length <= 0) {
                            await getAllPlantsByRegion();
                        }
                    }}
                />
                <DetailsModal
                    id="flagged-forms"
                    modalTitle="Flagged Forms"
                    listHeadings={['Plant ID', 'Region', 'Type', 'State', 'User Name', 'Status']}
                    history={this.props.history}
                    listItemComponent={FlaggedFormListItem}
                    promise={async (UniqueId, type) => {
                        await getFormDetails(UniqueId, type);
                    }}
                />
                <RegionFilter
                    selectedValue={this.state.regionFilter}
                    className="region-filter"
                    key="region"
                    onChange={this.executeFilter}
                />
                <div className="reset-filters" >
                    <button className="reset-button" style={{ padding: '0 5px' }} onClick={this.handleFilterReset} >
                        {this.state.showFilter ? 'Remove Filters' : 'Add Filters'}
                    </button>
                </div>
                <ToggleSwitch
                    
                    buttonLabel={['Daily Forms', 'Monthly Forms', 'Quarterly Forms']}
                    activeIndex={this.handleActiveTab}
                    activeIndexOnLoad={this.state.activeIndex}
                />
                <div style={{ textAlign: 'center', paddingBottom: '10px' }} >
                    { this.state.activeIndex === 0 ? this.renderDailyFilterDropdown() : ''} 
                    {this.state.activeIndex === 1 ? this.renderMonthlyFilterDropdown() : ''}
                    {this.state.activeIndex === 2 ? this.renderQuarterlyFilterDropdown() : ''}
                </div>
                <Row className="show-grid line-chart-container" >
                    <Col sm={12} xs={12} style={styles.colStyle} >
                        <LineChart
                            onClick={this.state.activeIndex === 0 ? this.handleLineChartClick : null}
                            className="line-chart-responsive"
                            dataKey={this.state.lineChartDataKey}
                            data={this.state.lineChartData || dailyFormData}
                            barColors={this.state.barColors}
                        />
                        {this.state.showFilter ? <div className="filter-container" style={{ display: 'block' }} >
                            <RDatePicker
                                value={this.state.dashboardFilterValue}
                                onChange={e => this.handleLineChartFilter(e.toString())} />
                            
                        </div> : ''}
                        <div className="flagged-form-buttons-wrap" >
                                <button
                                    style={{ padding: '0 8px' }}
                                    onClick={this.handleOnCompletedFlaggedFormClick}
                                    className="dashboard-button" >View All Completed Flagged Forms
                                </button>
                            <span style={{ padding: '20px' }} />
                            < button
                                style={{ padding: '0 8px' }}
                                onClick={this.handleOnInCompletedFlaggedFormClick}
                                className="dashboard-button" >View All Incomplete Flagged Forms
                            </button>
                        </div>
                    </Col>
                </Row>
                <div className="bar-chart-container">
                    <DailyChart
                        onFilter={() => this.setState({ isLoading: true })}
                        dailyForms={this.props.dailyForms}
                        dailyFlaggedForms={this.props.dailyFlaggedForms}
                        history={this.props.history}
                        dailyFormSummary={dailyFormSummary}
                        activeDate={this.state.dailyFilter}
                        activeRegion={this.state.regionFilter}
                        instance={this}
                        resetFilters={this.props.resetFilters}
                        dailyFlaggedFormCount={this.props.dailyFlaggedFormCount}
                        showFilter={true}
                        quarterlyFilterDate={this.props.filterData.quarterlyFilter.date}
                        monthlyFilterDate={this.props.filterData.monthlyFilter.date}
                    />
                    <MonthlyChart
                        onFilter={() => this.setState({ isLoading: true })}
                        monthlyForms={this.props.monthlyForms}
                        monthlyFlaggedForms={this.props.monthlyFlaggedForms}
                        history={this.props.history}
                        monthlyFormData={monthlyFormData}
                        filterData={this.props.filterData}
                        instance={this}
                        resetFilters={this.props.resetFilters}
                        monthlyFlaggedFormCount={this.props.monthlyFlaggedFormCount}
                        activeDate={this.state.monthlyFilter}
                        activeRegion={this.state.regionFilter}
                        showFilter={true}
                        quarterlyFilterDate={this.props.filterData.quarterlyFilter.date}
                        dailyFilterDate={this.props.filterData.dailyFilter.date}
                    />
                    <QuarterlyChart
                        quarterlyForms={quarterlyForms}
                        quarterlySummary={quarterlySummary}
                        instance={this}
                        filterData={this.props.filterData}
                        onFilter={() => this.setState({ isLoading: true })}
                        quarterlyFlaggedForms={this.props.quarterlyFlaggedForms}
                        history={this.props.history}
                        resetFilters={this.props.resetFilters}
                        quarterlyFlaggedFormCount={this.props.quarterlyFlaggedFormCount}
                        showFilter={true}
                        activeDate={this.state.quarterlyFilter}
                        activeRegion={this.state.regionFilter}
                        monthlyFilterDate={this.props.filterData.monthlyFilter.date}
                        dailyFilterDate={this.props.filterData.dailyFilter.date}
                    />
                </div>
            </div>,
        ];
    }
}

const styles = {
    rowStyle: {
        margin: 0
    },
    colStyle: {
        float: 'none',
        display: 'inline-block',
    },
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Dashboard/DashboardData.tsx